import TaxesFeesModal from './TaxesFeesModal';

export default TaxesFeesModal;
